export interface AvailableSites {
  status: boolean;
  response: AvailableSitesResponse;
}

export interface AvailableSitesResponse {
  data: AvailableSitesResponseData[];
}

export interface AvailableSitesResponseData {
  isMapped: boolean;
  name: string;
  _id: string;
}